export const orderTypeIds = {
    undefined: 0,
    // Платный заказ
    payed: 1,
    // Госзаказ
    government: 2,
    // Заявка от клиента
    clientRequest: 3,
    // Заявка не платная и не гос
    nonReferral: 4,
}